// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__eXlm3","colMin":"styles_colMin__2N-hS","colCheckbox":"styles_colCheckbox__HBvEI"};